import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouteNavigateService } from '../../services/route-navigation/route-navigate.service';
import { LocationManagerService } from '../../services/location-manager/location-manager.service';
import { RoutePlannerViaService } from '../../services/route-via/route-via.service';
import { AppUtilityService } from 'src/app/core/services/app-utility/app-utility.service';
import { EventsService } from 'src/app/core/services/events.service';
import { AAGoogleMapEvents } from 'src/app/core/events/events';

@Component({
    selector: 'aa-route-navigate',
    templateUrl: './route-navigate.component.html',
    styleUrls: ['./route-navigate.component.scss'],
    standalone: false
})

export class RouteNavigateComponent implements OnInit, OnDestroy {

  private isRouteSearchPerformed = false;

  constructor(private routeNavigationService: RouteNavigateService,
    private locationManager: LocationManagerService,
    public eventServices: EventsService,
    public routePlannerViaService: RoutePlannerViaService,
    public appUtilityService: AppUtilityService) { }

  ngOnInit() {
    this.eventServices.on(AAGoogleMapEvents.UPDATE_MAP, this.onUpdateMap);
  }

  ngOnDestroy() {
    this.eventServices.remove(AAGoogleMapEvents.UPDATE_MAP, this.onUpdateMap);
  }

  routeNavigation(): void {
    const lat = this.locationManager.toLocation.latLng.lat;
    const lng = this.locationManager.toLocation.latLng.lng;
    let url = this.routeNavigationService.getNavigationURL();
    // check if it has LAT & LON tokens
    if (url.indexOf('{LON}') > 0) {
      url = url.replace('{LAT}', lat);
      url = url.replace('{LON}', lng);
    } else {
      url = url + lat + ',' + lng;
    }

    if (url.indexOf('apple') > 0) {
      window.location.assign(url);
    } else {
      window.open(url, '_blank');
    }
  }

  /**
   * MOBILE VIEW
   * Listen the event when use start route search & set the value as true
   */
  private onUpdateMap = () => {
    this.isRouteSearchPerformed = true;
  }

  /**
  * MOBILE VIEW
  * Hide the navigate button if Via list
  * return the Via list length
  */
  get getViaListLength(): boolean {
    const viaListLength = (this.routePlannerViaService?.viaRouteList) ? this.routePlannerViaService.viaRouteList.length : 0;
    const showNavigateBtn = viaListLength === 0 && this.isRouteSearchPerformed && !this.appUtilityService.isDesktop;
    return showNavigateBtn;
  }
}
